import {
  CameraStatus,
  PlayerStatus,
  VideoControllersType,
} from '@/globals/enums';
import { tracer } from './print';
import dayjs from 'dayjs';

export function handleVideoOff(context, hole) {
  if (context.isDiscontinuity || context.isLive) {
    // avoid running discontinuity when the discontinuity is enabled/live already
    return;
  }
  tracer('handleVideoOff', { hole });
  context.currentVideoHole = hole;
  if (context.isPlaying) {
    context.playerTimer.start();
  }
  // change flags for discontinuity
  context.clearEndDiscontinuityTimeout();
  context.isDiscontinuity = true;
  context.handleCameraStatus(PlayerStatus.Discontinuity);

  // display `No Video` error messge
  context.errorMessage = {
    text: '録画映像なし',
    theme: 'dark-bg',
  };
  context.clearWaitingForNewTimestamp();
}
export function endDiscontinuity(context, { videoTime, startTimestamp } = {}) {
  if (!context.isDiscontinuity) {
    return;
  }

  tracer('endDiscontinuity', {
    videoTime,
    startTimestamp: dayjs(startTimestamp).format('HH:mm:ss'),
  });
  const currentVideoHole = { ...context.currentVideoHole };
  if (currentVideoHole?.endFrag?.codecChanged) {
    context.seek({
      startTimestamp: currentVideoHole.startUnix,
      controller: VideoControllersType.DragSeekbar,
    });
    return;
  }
  context.currentVideoHole = null;
  const video = context.remoteViewRef || context.remoteView;
  if (video) {
    if (videoTime) {
      video.currentTime = videoTime;
    }
    if (context.isPlaying) {
      const promise = video.play();
      if (promise !== undefined) {
        return promise
          .then(() => {
            resetDiscontinuity(context);
            context.resetPlayerTimerWithNewTimestamp(startTimestamp);
            context.clearWaitingForNewTimestamp();
            return currentVideoHole;
          })
          .catch((e) => {
            if (
              e.name === 'NotAllowedError' ||
              e.name === 'NotSupportedError'
            ) {
              context.handleNotAllowVideoPlay();
            }
            return currentVideoHole;
          });
      }
    } else {
      resetDiscontinuity(context);
      context.resetPlayerTimerWithNewTimestamp(startTimestamp);
      context.clearWaitingForNewTimestamp();
    }
    return Promise.resolve(currentVideoHole);
  }
}
export function resetDiscontinuity(context) {
  context.handleCameraStatus(CameraStatus.Connected);
  context.isDiscontinuity = false;
  context.backwardGapTime = null;
  clearTimeout(window[context.endDiscontinuityTimeout]);
  context.endDiscontinuityTimeout = setTimeout(() => {
    context.errorMessage = null;
  }, 500);
}
